import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditFollowUpMedium = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [FollowUpMediumName, setFollowUpMediumName] = useState('');
  const { FollowUpMediumId } = useParams();
  const navigate = useNavigate();

  // Static FollowUpMedium data
  const staticFollowUpMediumData = [
    { FollowUpMediumId: 1, FollowUpMediumName: 'Phone' },
    { FollowUpMediumId: 2, FollowUpMediumName: 'SMS' },
    { FollowUpMediumId: 3, FollowUpMediumName: 'WhatsApp' },
    { FollowUpMediumId: 4, FollowUpMediumName: 'Email' },
    { FollowUpMediumId: 5, FollowUpMediumName: 'Google Meet' },
    { FollowUpMediumId: 6, FollowUpMediumName: 'Instagram' },
    { FollowUpMediumId: 7, FollowUpMediumName: 'Telegram' },
  ];

  useEffect(() => {
    // Find the FollowUpMedium to edit based on FollowUpMediumId
    const FollowUpMedium = staticFollowUpMediumData.find(
      FollowUpMedium => FollowUpMedium.FollowUpMediumId === parseInt(FollowUpMediumId)
    );
    if (FollowUpMedium) {
      setFollowUpMediumName(FollowUpMedium.FollowUpMediumName);
    } else {
      alert('FollowUpMedium not found');
    }
  }, [FollowUpMediumId]);

  const handleUpdate = () => {
    if (FollowUpMediumName) {
      console.log('Updated FollowUpMedium:', FollowUpMediumName);
      setShowSuccessModal(true);
    } else {
      alert('Please enter a FollowUpMedium name');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Follow Up Medium
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
          <TextField
            label="Follow Up Medium"
            variant="outlined"
            fullWidth
            value={FollowUpMediumName}
            onChange={(e) => setFollowUpMediumName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!FollowUpMediumName && "Enter FollowUpMedium Name"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!FollowUpMediumName}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              FollowUpMedium Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              FollowUpMedium Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditFollowUpMedium;